// Comprueba si un valor es null, undefined o un string vacío ('')
// Útil para sustituir comprobaciones como `value !== null` que no contemplan `undefined`
export const isEmptyValue = (value: unknown): boolean => {
	return (
		value === null ||
		value === undefined ||
		(typeof value === 'string' && value.trim() === '') ||
		value === 'null' ||
		value === 'undefined'
	);
};
